import RoleBadges from './RoleBadges';

// THE canonical author-name treatment (same rule as Profile/ProfileName):
// "displayName @username", collapsed to just "@username" when the display
// name is missing or identical — never a bare display name without the
// handle. Role badges always follow the name. Typography is inherited from
// the parent: this renders only a <span> (pass className for truncation
// etc.) plus <RoleBadges/>, so every card keeps its own styling.
export default function AuthorName({ author, className }) {
  if (!author) return null;
  const username = author.username || author.name;
  if (!username) return null;
  const displayName = (author.displayName || author.display_name || '').trim();
  const collapsed = !displayName || displayName === username;
  return (
    <>
      <span className={className}>
        {collapsed ? (
          <>@{username}</>
        ) : (
          <>
            {displayName} <span className="tw-opacity-60">@{username}</span>
          </>
        )}
      </span>
      <RoleBadges roles={author.roles} />
    </>
  );
}
